<script setup>
import "@/styles/css/about.scss";
import { onMounted } from "vue";
import "slick-carousel/slick/slick.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
onMounted(() => {
  // require('@/assets/js/about.js')
  // return;
  $(document).ready(function () {
    $(".team_mb_slider").slick({
      dots: false,
      infinite: false,
      variableWidth: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: $(".prev-slide-team"),
      nextArrow: $(".next-slide-team"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
      ],
    }),
      $(".view_all_timeline").click(function () {
        $(".timeline").addClass("active"), $(this).hide();
      }),
      $(".fancy_vd").fancybox({
        width: 1287,
        height: 720,
        fitToView: !1,
        autoSize: !1,
      });
  });
});
</script>
<template>
  <main class="upstox-design-base about-us-new">
    <section class="about_bnnr">
      <div class="container">
        <div class="abt_bnt_txt">
          <h1 class="h2_heading">
            Our mission is to help every Indian confidently Up their wealth
          </h1>

          <a
            class="btn prple_outline_btn"
            data-toggle="modal"
            data-target="#our_vision"
            target="_blank"
            >Our vision Statement
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <path
                d="M7.53317 13.4512C7.41095 13.3289 7.34695 13.1734 7.34117 12.9845C7.3354 12.7956 7.39384 12.64 7.51651 12.5178L10.7832 9.25115H3.33317C3.14428 9.25115 2.98584 9.18715 2.85784 9.05915C2.72984 8.93115 2.66606 8.77293 2.66651 8.58449C2.66651 8.3956 2.73051 8.23715 2.85851 8.10915C2.98651 7.98115 3.14473 7.91737 3.33317 7.91782H10.7832L7.51651 4.65115C7.39428 4.52893 7.33584 4.37337 7.34117 4.18448C7.34651 3.9956 7.41051 3.84004 7.53317 3.71782C7.6554 3.5956 7.81095 3.53448 7.99984 3.53448C8.18873 3.53448 8.34428 3.5956 8.46651 3.71782L12.8665 8.11782C12.9332 8.17337 12.9805 8.24293 13.0085 8.32648C13.0365 8.41004 13.0503 8.49604 13.0498 8.58449C13.0498 8.67337 13.0361 8.75671 13.0085 8.83449C12.981 8.91226 12.9336 8.98448 12.8665 9.05115L8.46651 13.4512C8.34428 13.5734 8.18873 13.6345 7.99984 13.6345C7.81095 13.6345 7.6554 13.5734 7.53317 13.4512Z"
                fill="#61399F"
              ></path>
            </svg>
          </a>
        </div>
        <div class="our_story_text"></div>
        <div class="what_we_build text-center">
          <h2 class="h2_heading">How do we achieve this?</h2>
          <p class="by-making-paragraph">By making investing:</p>
          <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="card we_build_card">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/accessible.webp
                    "
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/accessible.png"
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                  />
                </picture>
                <h6>Accessible</h6>
                <p>
                  Powerful mobile and desktop platform accessible to all Indians
                </p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"
                  target="_blank"
                  class="btn brdlss_btn"
                  >Download App<img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/prl_arrw.svg"
                    alt="right-arrow"
                /></a>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="card we_build_card">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/affordable.webp
                    "
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/affordable.png"
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                  />
                </picture>

                <h6>Affordable</h6>
                <p>
                  Pay just up to ₹20 for equity, F&amp;O, commodity or currency
                  orders and ₹0 on Mutual Funds and IPOs
                </p>
                <a
                  href="/brokerage-charges/"
                  target="_blank"
                  class="btn brdlss_btn"
                  >See pricing<img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/prl_arrw.svg"
                    alt="right-arrow"
                /></a>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="card we_build_card">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/simple.webp
                    "
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/simple.png"
                    alt="what-we-build"
                    loading="lazy"
                    class="img-responsive"
                  />
                </picture>
                <h6>Simple</h6>
                <p>
                  Dedicated modes for investors and traders to support their
                  individual needs and goals
                </p>
                <a
                  href="/invest-in-share-market/"
                  target="_blank"
                  class="btn brdlss_btn"
                  >Start learning<img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/prl_arrw.svg"
                    alt="right-arrow"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vlt_bg"></div>
    </section>

    <section class="our_journey">
      <div class="container">
        <div class="timeline_heading_txt text-center">
          <h2 class="h2_heading">Our Journey</h2>
          <p class="p_txt">
            Take a walk down the memory lane, from Upstox’s humble beginnings
            all the way to becoming one of India’s largest trading platforms.
            <a
              class="btn prple_outline_btn"
              data-toggle="modal"
              data-target="#read_our_story"
              target="_blank"
              >Read More</a
            >
          </p>
        </div>
        <div class="inner_hgt">
          <ul class="timeline list-unstyled">
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/rksv_logo.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/rksv_logo.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2010</label>
                  <h6>Its Official!</h6>
                  <p>
                    We receive our licence to begin our trading business in
                    India under Upstox Securities Pvt. Ltd.
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/start_up.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/start_up.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2012</label>
                  <h6>Start-UP</h6>
                  <p>
                    We enter the retail trading space becoming the first to
                    launch unlimited trading plans
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/crore.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/crore.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2014</label>
                  <h6>₹4000 Cr+</h6>
                  <p>
                    Within 2 years, we hit a trading turnover of ₹4000 cr thanks
                    to our loyal customer base
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/backed_by_best.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/backed_by_best.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2016</label>
                  <h6>Backed by the best</h6>
                  <p>
                    We get our first round of funding (Series A) worth $4 Mn
                    from Kalaari Capital
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/ratan_tata.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/ratan_tata.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2016</label>
                  <h6>Trusted by the best</h6>
                  <p>
                    Along with Kalaari Capital, in the same year we get funded
                    by Mr.Ratan Tata
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/level_up.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/level_up.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2016</label>
                  <h6>Levelling-UP</h6>
                  <p>
                    RKSV securities becomes Upstox and is the first in the
                    industry to launch a completely paperless account opening
                    process
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/trusted_by_best.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/trusted_by_best.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2019</label>
                  <h6>Trusted by the best</h6>
                  <p>
                    We receive another round of funding (Series B) from Tiger
                    Global
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/lakh_and_counting.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/lakh_and_counting.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>

                <div>
                  <label>2020</label>
                  <h6>10 Lakh and counting..</h6>
                  <p>
                    We get awarded by CDSL for being the first broker to onboard
                    the highest number of users in a single month
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/rksv_logo.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/rksv_logo.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2021</label>
                  <h6>Upwards &amp; onwards</h6>
                  <p>
                    With another round of funding from Tiger Global (Series C),
                    our valuation rises to $3.5 bn, getting us a spot in the
                    list of Indian unicorn startups!
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/crossing_boundaries.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/crossing_boundaries.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2021</label>
                  <h6>Crossing boundaries</h6>
                  <p>We become the official partners for TNPL, IPL,and ICC</p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/the_upgrade.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/the_upgrade.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2021</label>
                  <h6>The Upgrade</h6>
                  <p>
                    We get a new identity and announce the launch of a newer,
                    faster and better app with advanced features such as MTF,
                    smart lists, smart filters and more.
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline_content left">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/start_up.webp
                    "
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/start_up.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2022</label>
                  <h6>$60,000cr+</h6>
                  <p>Our trading turnover crosses the ₹60,000cr+ mark!</p>
                </div>
              </div>
            </li>
            <li class="timeline_content right">
              <div class="content">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/topped_up.webp
                    "
                    media="(min-width: 767px)"
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/webp"
                  />

                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/topped_up.png
                    "
                    media="(min-width: 768px)"
                    alt="rksv-logo"
                    loading="lazy"
                    type="image/png"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/topped_up.png"
                    alt="rksv-logo"
                    loading="lazy"
                  />
                </picture>
                <div>
                  <label>2023</label>
                  <h6>Topped-Up!</h6>
                  <p>
                    Introduced a whole new Mutual Fund experience featuring Top
                    Rated funds to help you Invest Right, Invest Now
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <button type="button" class="btn prple_btn view_all_timeline">
            View full timeline
          </button>
        </div>
      </div>
    </section>

    <section class="meet_the_team">
      <div class="container">
        <div class="meet_tm_heading text-center">
          <h2 class="h2_heading">Meet the Founders</h2>
          <p class="p_txt">Who made it all possible.</p>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card team_card">
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/about/new/ravi-new.webp
                  "
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/ravi-new.png"
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                />
              </picture>
              <div class="card_body">
                <h5>Ravi Kumar</h5>
                <label>CO - FOUNDER</label>
                <p>
                  Ravi started trading when he was 16. A story of him from his
                  teenage years showcases his love for trading and the stock
                  markets – He would use his brea...
                </p>
                <!-- <a href="#" class="btn prple_outline_btn">Read Story</a> -->
                <a
                  class="btn brdlss_btn"
                  data-toggle="modal"
                  data-target="#ravi_modal"
                  target="_blank"
                  >Read Story
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      d="M7.53317 13.4512C7.41095 13.3289 7.34695 13.1734 7.34117 12.9845C7.3354 12.7956 7.39384 12.64 7.51651 12.5178L10.7832 9.25115H3.33317C3.14428 9.25115 2.98584 9.18715 2.85784 9.05915C2.72984 8.93115 2.66606 8.77293 2.66651 8.58449C2.66651 8.3956 2.73051 8.23715 2.85851 8.10915C2.98651 7.98115 3.14473 7.91737 3.33317 7.91782H10.7832L7.51651 4.65115C7.39428 4.52893 7.33584 4.37337 7.34117 4.18448C7.34651 3.9956 7.41051 3.84004 7.53317 3.71782C7.6554 3.5956 7.81095 3.53448 7.99984 3.53448C8.18873 3.53448 8.34428 3.5956 8.46651 3.71782L12.8665 8.11782C12.9332 8.17337 12.9805 8.24293 13.0085 8.32648C13.0365 8.41004 13.0503 8.49604 13.0498 8.58449C13.0498 8.67337 13.0361 8.75671 13.0085 8.83449C12.981 8.91226 12.9336 8.98448 12.8665 9.05115L8.46651 13.4512C8.34428 13.5734 8.18873 13.6345 7.99984 13.6345C7.81095 13.6345 7.6554 13.5734 7.53317 13.4512Z"
                      fill="#61399F"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card team_card">
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/about/new/kavitha-new.webp
                  "
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/kavitha-new.png"
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                />
              </picture>
              <div class="card_body">
                <h5>Kavitha Subramanian</h5>
                <label>CO - FOUNDER</label>
                <p>
                  Kavitha Subramanian is a co-founder at Upstox, where she is
                  responsible for growth, strategy, finance and customer
                  experience. Prior to Upstox, Kavitha w...
                </p>
                <a
                  href="#"
                  class="btn brdlss_btn"
                  data-toggle="modal"
                  data-target="#kavitha_modal"
                  >Read Story
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      d="M7.53317 13.4512C7.41095 13.3289 7.34695 13.1734 7.34117 12.9845C7.3354 12.7956 7.39384 12.64 7.51651 12.5178L10.7832 9.25115H3.33317C3.14428 9.25115 2.98584 9.18715 2.85784 9.05915C2.72984 8.93115 2.66606 8.77293 2.66651 8.58449C2.66651 8.3956 2.73051 8.23715 2.85851 8.10915C2.98651 7.98115 3.14473 7.91737 3.33317 7.91782H10.7832L7.51651 4.65115C7.39428 4.52893 7.33584 4.37337 7.34117 4.18448C7.34651 3.9956 7.41051 3.84004 7.53317 3.71782C7.6554 3.5956 7.81095 3.53448 7.99984 3.53448C8.18873 3.53448 8.34428 3.5956 8.46651 3.71782L12.8665 8.11782C12.9332 8.17337 12.9805 8.24293 13.0085 8.32648C13.0365 8.41004 13.0503 8.49604 13.0498 8.58449C13.0498 8.67337 13.0361 8.75671 13.0085 8.83449C12.981 8.91226 12.9336 8.98448 12.8665 9.05115L8.46651 13.4512C8.34428 13.5734 8.18873 13.6345 7.99984 13.6345C7.81095 13.6345 7.6554 13.5734 7.53317 13.4512Z"
                      fill="#61399F"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="card team_card">
              <picture>
                <source
                  srcset="
                    @/styles/img/about/new/Kapil.jpg
                  "
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="@/styles/img/about/new/Kapil.jpg"
                  class="img-responsive"
                  alt="team-img"
                  loading="lazy"
                />
              </picture>
              <div class="card_body">
                <h5>Kapil Jaikalyani</h5>
                <label>CO - FOUNDER</label>
                <p>
                  KAPIL JAIKALYANI Kapil Jaikalyani, based in Mumbai, MH, IN, is
                  currently a Associate Director at upstox Securities (India)
                  Private Limited at upstox SECURITIES INDIA PRIVATE LIMITED.
                  Kapil Jaikalyani brings experience from previous roles at
                  National Stock Exchange of India Limited, ICICI Lombard and
                  NSE IFSC LIMITED. Kapil Jaikalyani holds a 2003 - 2005 MBA in
                  Finance & Marketing @ NYSSIMR. With a robust skill set that
                  includes Capital Markets, Mutual Funds, Risk Management,
                  Derivatives, Equities and more.
                </p>
                <a
                  href="#"
                  class="btn brdlss_btn"
                  data-toggle="modal"
                  data-target="#shrini_modal"
                  >Read Story
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      d="M7.53317 13.4512C7.41095 13.3289 7.34695 13.1734 7.34117 12.9845C7.3354 12.7956 7.39384 12.64 7.51651 12.5178L10.7832 9.25115H3.33317C3.14428 9.25115 2.98584 9.18715 2.85784 9.05915C2.72984 8.93115 2.66606 8.77293 2.66651 8.58449C2.66651 8.3956 2.73051 8.23715 2.85851 8.10915C2.98651 7.98115 3.14473 7.91737 3.33317 7.91782H10.7832L7.51651 4.65115C7.39428 4.52893 7.33584 4.37337 7.34117 4.18448C7.34651 3.9956 7.41051 3.84004 7.53317 3.71782C7.6554 3.5956 7.81095 3.53448 7.99984 3.53448C8.18873 3.53448 8.34428 3.5956 8.46651 3.71782L12.8665 8.11782C12.9332 8.17337 12.9805 8.24293 13.0085 8.32648C13.0365 8.41004 13.0503 8.49604 13.0498 8.58449C13.0498 8.67337 13.0361 8.75671 13.0085 8.83449C12.981 8.91226 12.9336 8.98448 12.8665 9.05115L8.46651 13.4512C8.34428 13.5734 8.18873 13.6345 7.99984 13.6345C7.81095 13.6345 7.6554 13.5734 7.53317 13.4512Z"
                      fill="#61399F"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- start of slider about section -->
    <!-- end of slider about section -->
    <section class="team_sec">
      <div class="container">
        <div class="mbile-hide">
          <h2 class="h2_heading team-sec-title">Meet the changemakers</h2>
          <div class="team_mb_slider global_slick_dots slick-slider">
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/aditya_vyas.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/aditya_vyas.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>VP Product</label>
                <h5>Aditya Vyas</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/aditya-vyas-59b2a054/"
                  target="_blank"
                  tabindex="0"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/puneet_maheshwari.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/puneet_maheshwari.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>Director &amp; VP Product</label>
                <h5>Puneet Maheshwari</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/puneet-maheshwari-41201925/"
                  target="_blank"
                  tabindex="0"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/amit_lalan.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/amit_lalan.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>Director</label>
                <h5>Amit Lalan</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/amit-lalan-13274a192/"
                  target="_blank"
                  tabindex="0"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/mike_akeroyd.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/mike_akeroyd.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>VP Product</label>
                <h5>Mike Akeroyd</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/akeroyd/"
                  target="_blank"
                  tabindex="0"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/kapil_kothari.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/kapil_kothari.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>Principal officer</label>
                <h5>Kapil Kothari</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/kapil-kothari-89961b2a5/"
                  target="_blank"
                  tabindex="-1"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/elvis.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/elvis.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>HR</label>
                <h5>Elvis D’Souza</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/elvis-d-souza-995a57298/"
                  target="_blank"
                  tabindex="-1"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/kamaiah-nadavala.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/kamaiah-nadavala.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>VP Infosec</label>
                <h5>Kamaiah Nadavala</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/kamaiah-nadavala/"
                  target="_blank"
                  tabindex="-1"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
            <div class="card team_mb_card">
              <div>
                <figure>
                  <picture>
                    <source
                      srcset="
                        https://upstox.com/app/themes/upstox/dist/img/about/new/siddharth-patnaik.webp
                      "
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                      type="image/webp"
                    />

                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/about/new/siddharth-patnaik.png"
                      class="img-responsive"
                      alt="team-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
                <label>VP Engineering</label>
                <h5>Siddharth Patnaik</h5>
              </div>
              <span
                ><a
                  href="https://www.linkedin.com/in/siddharth-patnaik-0a03b8/"
                  target="_blank"
                  tabindex="-1"
                  ><img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/linkedin_logo.svg"
                    alt="linkedin-logo" /></a
              ></span>
            </div>
          </div>
          <ul class="custom_arrows_team">
            <li
              class="prev-slide-team slick-arrow slick-disabled"
              aria-disabled="true"
              style=""
            >
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/about/new/slider_arrow.svg"
                alt="left-arrow"
              />
            </li>
            <li
              class="next-slide-team slick-arrow"
              style=""
              aria-disabled="false"
            >
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/about/new/slider_arrow.svg"
                alt="right-arrow"
              />
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="trusted_indians-sec">
      <div class="container">
        <h2 class="trusted-title">Loved &amp; Trusted by 1.3 crore+ Indians</h2>
        <div class="row">
          <div class="col-md-3">
            <div class="trusted-column">
              <div class="trusted-img">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/cdsl.webp
                    "
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/cdsl.png"
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                  />
                </picture>
              </div>
              <p>
                Highest number of Demat Accounts in a single month by CDSL in
                October 2021
              </p>
            </div>
          </div>

          <div class="col-md-3">
            <div class="trusted-column trusted-sapce">
              <div class="trusted-img">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/best_innovation.webp
                    "
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/best_innovation.png"
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                  />
                </picture>
              </div>
              <p>Best innovation in wealth management in 2020</p>
            </div>
          </div>

          <div class="col-md-3">
            <div class="trusted-column trusted-sapce">
              <div class="trusted-img">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/cdsl.webp
                    "
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/cdsl.png"
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                  />
                </picture>
              </div>
              <p>
                Highest number of accounts in a single month by a broker in
                (2019, 2020)
              </p>
            </div>
          </div>

          <div class="col-md-3">
            <div class="trusted-column trusted-sapce">
              <div class="trusted-img">
                <picture>
                  <source
                    srcset="
                      https://upstox.com/app/themes/upstox/dist/img/about/new/mcx.webp
                    "
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                    type="image/webp"
                  />

                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/about/new/mcx.png"
                    class="img-responsive"
                    alt="team-img"
                    loading="lazy"
                  />
                </picture>
              </div>
              <p>Most promising broking house of the year by MCX in 2019</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal -->
    <div
      class="modal fade team_popup"
      id="ravi_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/close_icon.svg"
                  alt="close-icon"
              /></span>
            </button>
            <div class="prof_sec">
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/about/new/ravi-new.webp
                  "
                  alt="profile-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/ravi-new.png"
                  alt="profile-img"
                  loading="lazy"
                />
              </picture>
              <div class="prof_heading">
                <h6>Ravi Kumar</h6>
                <span>Co-Founder</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <p>
              Ravi started trading when he was 16. A story of him from his
              teenage years showcases his love for trading and the stock markets
              – He would use his breaks in highschool to call back home to
              instruct his family members to place a stock purchase order via
              the phone. His love and passion for trading took him to a short
              stint at TD Ameritrade’s flagship Thinkorswim trading platform;
              post which he along with his brother – Raghu, started an automated
              proprietary trading desk in Chicago, where they successfully
              turned a few thousand dollars of capital into a few million
              dollars in three years.
            </p>
            <p>
              In the midst of the 2008 crash, Ravi and his brother moved to
              India where they envisaged a tremendous opportunity with the
              growth potential in the country. In 2009, Ravi co-founded the then
              Upstox Securities along with his brother Raghu Kumar and Shrini
              Viswanath. He has been instrumental in taking Upstox to being the
              second largest brokerage in India from its 47th position in 2017.
            </p>
            <p>
              At the helm of Upstox, Ravi is responsible for overseeing key
              business decisions and driving corporate strategy. Ravi holds a
              degree in Computer Science from the University of
              California–Irvine.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade team_popup"
      id="kavitha_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/close_icon.svg"
                  alt="close-icon"
              /></span>
            </button>
            <div class="prof_sec">
              <picture>
                <source
                  srcset="
                    https://upstox.com/app/themes/upstox/dist/img/about/new/kavitha-new.webp
                  "
                  alt="profile-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/kavitha-new.png"
                  alt="profile-img"
                  loading="lazy"
                />
              </picture>
              <div class="prof_heading">
                <h6>Kavitha Subramanian</h6>
                <span>Co-Founder</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <p>
              Kavitha Subramanian is a co-founder at Upstox, where she is
              responsible for growth, strategy, finance and customer experience.
              Prior to Upstox, Kavitha was a private equity investor at Leapfrog
              Investments and Actis Investments. She was a management consultant
              at McKinsey and Co. and also worked at SKS Microfinance. In her
              microfinance experience, she worked with rural women helping them
              with access to capital and financial growth. Seeing how wealth
              directly changed their lives made her a big believer in the power
              of financial inclusion at scale.
            </p>
            <p>
              With her deep understanding of customer behaviour and experience
              in managing key responsibilities at leading financial firms, she
              has been instrumental in making Upstox the fastest-growing
              brokerage firm in the country.
            </p>
            <p>
              Kavitha holds B.Tech and M.Tech degrees in Electrical Engineering
              from the Indian Institute of Technology, Bombay, and an MBA from
              the University of Pennsylvania’s Wharton School, USA.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade team_popup"
      id="shrini_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/close_icon.svg"
                  alt="close-icon"
              /></span>
            </button>
            <div class="prof_sec">
              <picture>
                <source
                  srcset="
                    @/styles/img/about/new/Kapil.jpg
                  "
                  alt="profile-img"
                  loading="lazy"
                  type="image/webp"
                />

                <img
                  src="@/styles/img/about/new/Kapil.jpg"
                  alt="profile-img"
                  loading="lazy"
                />
              </picture>

              <div class="prof_heading">
                <h6>Kapil Jaikalyani</h6>
                <span>Co-Founder</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <p>
              KAPIL JAIKALYANI Kapil Jaikalyani, based in Mumbai, MH, IN, is
              currently a Associate Director at upstox Securities (India)
              Private Limited at upstox SECURITIES INDIA PRIVATE LIMITED. Kapil
              Jaikalyani brings experience from previous roles at National Stock
              Exchange of India Limited, ICICI Lombard and NSE IFSC LIMITED.
              Kapil Jaikalyani holds a 2003 - 2005 MBA in Finance & Marketing @
              NYSSIMR. With a robust skill set that includes Capital Markets,
              Mutual Funds, Risk Management, Derivatives, Equities and more.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Read Our Story -->
    <div
      class="modal fade team_popup our_story_popup story-top"
      id="read_our_story"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/close_icon.svg"
                  alt="close-icon"
              /></span>
            </button>
            <div class="prof_sec">
              <div class="prof_heading">
                <h6>Our story</h6>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <p>
              We have been in the business of building wealth for our customers
              for over a decade. Ravi, Shrini and Raghu had spent most of their
              lives in the United States where they had started multiple
              companies together. One of their annual family trips to India in
              2009 turned into a life changing moment when they saw the
              tremendous potential in the Indian market - back then, the equity
              market participation in India was just 2%.
            </p>
            <p>
              So Upstox was born in 2009 (then known as RKSV) in a small
              apartment in Delhi, serving a small cohort of customers, helping
              them grow their investments in the public markets. We then moved
              to Mumbai, and momentum grew. Thousands of customers joined us
              purely through word of mouth. Kavitha joined the team a few years
              into our journey and supercharged our growth, strategy, finance
              and operations. This was the beginning of our exponential scaling.
            </p>
            <p>
              We kept innovating at the cutting edge of fintech, even before
              fintech was a thing! We were the first in the industry to launch
              unlimited trading plans at a fixed price. Another first was going
              completely paperless for our onboarding back in 2016. Thanks to
              the 'financial superhighway' innovation of the government (the
              push for digital identity via Aadhar and eKYC and the push for
              digital payments), our scale grew by orders of magnitude. We
              expanded our proposition from India to Bharat, with 70% of our new
              users coming from Tier 2 / 3 markets. This exponential growth came
              because of reducing barriers to entry to all customers.
            </p>
            <p>
              In 2021, we took this rocketship to the moon with our partnership
              with the Indian Premier League (IPL). In 2020, we had crossed a
              cumulative number of a million customers, and in 2021, we added
              the same number in a single month! Our first nationwide
              partnership with the world's largest cricketing league along with
              our mass media campaign made us a household brand across the
              country. We are just getting started, and we will continue to
              build for every Indian's prosperity.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Our Vision -->
    <div
      class="modal fade team_popup our_story_popup"
      id="our_vision"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><img
                  src="https://upstox.com/app/themes/upstox/dist/img/about/new/close_icon.svg"
                  alt="close-icon"
              /></span>
            </button>
            <div class="prof_sec">
              <div class="prof_heading">
                <h6>Our vision is to create a world where,</h6>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <ul>
              <li>Everyone has financial security without barriers</li>
              <li>
                Indians are investing in India’s growth by investing in her
                companies
              </li>
              <li>Wealth gap reduces. GDP per capita increases</li>
              <li>Everyone is financially literate and empowered</li>
              <li>
                Wealth becomes a given. So that everyone can focus on passion,
                creativity, growth, contribution &amp; excellence.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
